module.exports = __webpack_public_path__ + "img/int2.d857f156.jpg";